/**
 * The map, loaded only when somebody asks for it.
 *
 * MapLibre and its styles are about a megabyte. Every list gains a Map segment,
 * but most visits to a list never press it — and this app already splits
 * Firebase out of the main bundle for exactly this reason. Importing the map
 * eagerly would put that megabyte in front of every page load to serve a view
 * that is one of four.
 *
 * The fallback says the map is loading rather than showing an empty frame,
 * because on a slow connection the difference between "arriving" and "broken"
 * is the only thing the reader wants to know.
 */
import { lazy, Suspense } from 'react'
import type { MapRecord } from './ListMap'

const ListMapInner = lazy(() => import('./ListMap').then((m) => ({ default: m.ListMap })))

export type { MapRecord }

export function ListMap(props: {
  records: MapRecord[]
  onOpen: (id: string) => void
  emptyNote?: string
}) {
  return (
    <Suspense fallback={<div className="empty-note">Loading the map…</div>}>
      <ListMapInner {...props} />
    </Suspense>
  )
}
